import { AIChatbotInterpretationResponse } from '../../models/ai-chatbot-interpretation-response';
import { AIChatbotMessage } from '../../models/ai-chatbot-message';

const generatedTemplatesResponse: AIChatbotMessage['content'] = {
  type: 'presentations',
  data: {
    query: '',
    actions: '',
    templates: [
      {
        companyId: 'asd',
        name: 'Option 1',
        productCode: 'f566cfe800820feb384b04e842b3448240c4b5da',
        attributeData: { width: '1920', height: '1080', orientation: 'landscape', components: [{ id: 'component1', type: 'text', attributes: { text: { value: 'Sample Text 1' }, fontSize: { value: 24 }, color: { value: '#333333' } } }] }
      },
      {
        companyId: 'asd',
        name: 'Option 2',
        productCode: 'bc4b269550c5e83fd903c002c61c6a885085be1f',
        attributeData: { width: '1920', height: '1080', orientation: 'landscape', components: [{ id: 'component1', type: 'text', attributes: { text: { value: 'Sample Text 1' }, fontSize: { value: 24 }, color: { value: '#333333' } } }] }
      },
      {
        companyId: 'asd',
        name: 'Option 3',
        productCode: 'c4f3dc6ff5b41c3d74ea2d28755ff6c6cd8162ec',
        attributeData: { width: '1920', height: '1080', orientation: 'landscape', components: [{ id: 'component1', type: 'text', attributes: { text: { value: 'Sample Text 1' }, fontSize: { value: 24 }, color: { value: '#333333' } } }] }
      },]
  },
};

const generatedSinglePresentationResponse: AIChatbotMessage['content'] = {
  type: 'single_presentation',
  data: {
    companyId: 'asd',
    name: 'Option 1',
    productCode: 'f566cfe800820feb384b04e842b3448240c4b5da',
    attributeData: { width: '1920', height: '1080', orientation: 'landscape', components: [{ id: 'component1', type: 'text', attributes: { text: { value: 'Sample Text 1' }, fontSize: { value: 24 }, color: { value: '#333333' } } }] }
  },
};

const getInterpretationResponse = (
  message: string
): AIChatbotInterpretationResponse => {
  switch (message) {
    case '**Error**':
      throw new Error();

    case 'presentations':
      return {
        type: 'generating_presentations',
        loadingMessage: 'On it! Give me a moment while I make something cool.',
      };

    case 'More Presentations':
      return {
        type: 'generating_presentations',
        loadingMessage:
          "Sorry, that didn't quite work. Hang tight while I generate a few more ideas.",
      };

    case 'tweak':
      return {
        type: 'generating_presentations',
        loadingMessage:
          'Got it! I am changing to pink and purple colors for you.',
      };

    case 'Illustrative Images':
      return {
        type: 'generating_single_presentation',
        loadingMessage: 'Got it! I am changing the images for you.',
      };

    case 'Brighter Colors':
      return {
        type: 'generating_single_presentation',
        loadingMessage: 'Got it! I am brightening the colors for you.',
      };

    case 'Option 1':
    case 'Option 2':
    case 'Option 3':
      return {
        type: 'select_presentation',
        data: {
          companyId: 'asd',
          name: message,
          productCode: '123',
          attributeData: { width: '1920', height: '1080', orientation: 'landscape', components: [{ id: 'component1', type: 'text', attributes: { text: { value: 'Sample Text 1' }, fontSize: { value: 24 }, color: { value: '#333333' } } }] }
        },
      };

    case 'explicit_material':
      return {
        type: 'explicit_material',
        loadingMessage: 'Give me a moment while I make something cool.',
      };

    default:
      return {
        type: 'unsupported',
        loadingMessage: 'Give me a moment while I make something cool.',
      };
  }
};

export {
  generatedTemplatesResponse,
  generatedSinglePresentationResponse,
  getInterpretationResponse,
};
